import {
  AdminCreateUsageBillingUrlRequestBodyType,
  AdminCreateUsageBillingUrlResponseBodyType,
  CreateUsageBillingUrlRequestBodyType,
  CreateUsageBillingUrlResponseBodyType,
} from "@intelligems/ig-types";
import { useMutation } from "@tanstack/react-query";

import { api } from "../api";
import { ApiRequest } from "../types/api";

const createUsageBillingUrl = async (
  data: ApiRequest<CreateUsageBillingUrlRequestBodyType>
) => {
  const resp = await api.post<CreateUsageBillingUrlResponseBodyType>(
    "/v2/usage-billing-url",
    data.body
  );
  return resp.data;
};

export const useCreateUsageBillingUrl = () => {
  return useMutation<
    CreateUsageBillingUrlResponseBodyType,
    Error,
    ApiRequest<CreateUsageBillingUrlRequestBodyType>,
    any
  >({
    mutationKey: ["request-billing-url"],
    mutationFn: async (data) => createUsageBillingUrl(data),
    onSuccess: (data) => {
      window.open(data.billingUrl, "_blank");
    },
  });
};
